import React, { memo, useEffect } from 'react';

//Components.
import ActiveChallengeFormInputs from '../active-challenge-end-formInput/ActiveChallengeFormInputs';

//Functions.
import { calculateDaysRemaining, createDynamicStartDate, winningVotesRef } from '../../../../functions/momentJS';

//Dependencies.
import { FormGroup, Input, Label, Row, Col } from 'reactstrap';

import "./ChallengeAnnouncementInputs.styles.css";

const ChallengeAnnouncementInputs = ({ setChallengeAnnouncementDetails,challengeAnnouncementDetails, challengeEndConditions, setchallengeEndConditions, activeChallengeEndDateRef, winningVotesRef }) => {
   // console.log({ challengeAnnouncementDetails, challengeEndConditions });

   const { challengeAnnouncementHeadline, challengeAnnouncementEndDate, daysRemainingBeforeAnnouncementEnds } = challengeAnnouncementDetails;

   useEffect(() => {
      console.log({ challengeAnnouncementEndDate });
      return () => {

      }
   }, [challengeAnnouncementEndDate]);

   return (
      <div className='challengeAnnouncementContainer'>
         <span><strong className='text-danger'>X</strong> - CANCEL & CLOSE FORM</span>
         <FormGroup>
            <Label htmlFor='announcementHeadline'>
               <strong>ADD YOUR ANNOUNCEMENT HEADLINE HERE (THIS IS SIMILAR TO A NEWSPAPER HEADLINE AND IS WHAT MEMBERS WILL SEE).</strong>
            </Label>
            <Input type='textarea' style={{border: "3px solid black"}} id='announcementHeadline' placeholder='Add a catchy headline.' onChange={e => setChallengeAnnouncementDetails(prvDetails => ({...prvDetails, challengeAnnouncementHeadline: e.target.value}))} />
         </FormGroup> {/* add headline. */}
      
         <FormGroup>
            <Label htmlFor='annoucementEndDate'>
               <strong>WHAT <em>DATE</em> WILL THIS CHALLENGE ANNOUNCEMENT END?</strong>
            </Label>
            <Input type='date' id='announcementEndDate' min={createDynamicStartDate(1)} style={{border: "3px solid black"}} onChange={e => setChallengeAnnouncementDetails(prvDetails => ({...prvDetails, challengeAnnouncementEndDate: e.target.value, daysRemainingBeforeAnnouncementEnds: calculateDaysRemaining(e.target.value)}))} required />
         </FormGroup> {/* add announcement end date. */}

         {
            (challengeAnnouncementHeadline && challengeAnnouncementEndDate)
            &&
            <ActiveChallengeFormInputs
               activeChallengeEndDateRef={activeChallengeEndDateRef}
               challengeAnnouncementEndDate={challengeAnnouncementEndDate}
               challengeEndConditions={challengeEndConditions}               
               setchallengeEndConditions={setchallengeEndConditions}
               winningVotesRef={winningVotesRef}
            />
         }
      </div>
   )
}

export default memo(ChallengeAnnouncementInputs);